import React, { useState, useEffect } from 'react'
import { useSpring, animated } from '@react-spring/web'
import { styled } from 'styled-components'
import { getOverlay, useMissionStateSelector } from '../../../context'
import VideoOverlay from './VideoOverlay'
import ImageOverlay from './ImageOverlay'
type Props = {
	handleError?: (message: string) => void,
}

export default function VideoImageOverlay({ handleError }: Props): React$Node {
	const originalOverlay = useMissionStateSelector(getOverlay)
	const [overlay, setOverlay] = useState(null)

	const { scale } = useSpring({
		scale: originalOverlay ? 1 : 0,
		onRest: e => {
			if (!originalOverlay && overlay) {
				setOverlay(null)
			}
		},
	})

	useEffect(() => {
		if (originalOverlay) {
			setOverlay(originalOverlay)
		}
	}, [originalOverlay])

	return (
		overlay && (
			<Scaler style={{ transform: scale.interpolate(o => `scale(${o})`) }}>
				{overlay.type === 'VIDEO' ? (
					<VideoOverlay handleError={handleError} overlay={overlay} />
				) : overlay.type === 'IMAGE' ? (
					<ImageOverlay overlay={overlay} />
				) : null}
			</Scaler>
		)
	)
}

const Scaler = styled(animated.div)`
	position: absolute;
	top: 15%;
	left: 12.5%;
	z-index: ${({ theme }) => theme.zVisible};
	width: 75%;
	max-width: 75%;
	height: 70%;
	max-height: 70%;
	display: flex;
	justify-content: center;
	align-items: center;
	will-change: transform;
`
